import { WorldcupEventDtoStatus } from '../../../api/generated/worldcup/model/worldcupEventDtoStatus.ts';
import { WorldcupGrantSourceItemGameCode } from '../../../api/generated/worldcup/model/worldcupGrantSourceItemGameCode.ts';
import { WorldcupMatchItemResponseStatus } from '../../../api/generated/worldcup/model/worldcupMatchItemResponseStatus.ts';
import { WorldcupMatchItemResponseUiStatus } from '../../../api/generated/worldcup/model/worldcupMatchItemResponseUiStatus.ts';
import { WorldcupMyPredictionResponseResultStatus } from '../../../api/generated/worldcup/model/worldcupMyPredictionResponseResultStatus.ts';
import { WorldcupPredictionDtoResultStatus } from '../../../api/generated/worldcup/model/worldcupPredictionDtoResultStatus.ts';
import { WorldcupRoundDtoRoundCode } from '../../../api/generated/worldcup/model/worldcupRoundDtoRoundCode.ts';
import { WorldcupRoundDtoStatus } from '../../../api/generated/worldcup/model/worldcupRoundDtoStatus.ts';
import { buildWorldcupPageViewModel } from '../model/worldcupMappers';

const BASE_EVENT = {
  result: 'OK',
  event: {
    eventId: 1,
    title: '월드컵 예측 이벤트',
    startAt: '2026-07-05T00:00:00+09:00',
    endAt: '2026-07-15T23:59:59+09:00',
    status: WorldcupEventDtoStatus.ACTIVE,
    initialTickets: 0,
    pointsPerTicket: 50,
    maxTicketsDaily: 3,
    maxTicketsMatch: 3,
    bettingCloseHours: 2,
  },
  rounds: [
    {
      roundId: 101,
      eventId: 1,
      roundCode: WorldcupRoundDtoRoundCode.R16,
      roundName: '16강',
      sortOrder: 1,
      status: WorldcupRoundDtoStatus.OPEN,
      openAt: '2026-07-05T00:00:00+09:00',
      closedAt: null,
    },
    {
      roundId: 102,
      eventId: 1,
      roundCode: WorldcupRoundDtoRoundCode.QF,
      roundName: '8강',
      sortOrder: 2,
      status: WorldcupRoundDtoStatus.PENDING,
      openAt: null,
      closedAt: null,
    },
    {
      roundId: 103,
      eventId: 1,
      roundCode: WorldcupRoundDtoRoundCode.SF,
      roundName: '4강',
      sortOrder: 3,
      status: WorldcupRoundDtoStatus.PENDING,
      openAt: null,
      closedAt: null,
    },
    {
      roundId: 104,
      eventId: 1,
      roundCode: WorldcupRoundDtoRoundCode.THIRD,
      roundName: '3.4위',
      sortOrder: 4,
      status: WorldcupRoundDtoStatus.PENDING,
      openAt: null,
      closedAt: null,
    },
    {
      roundId: 105,
      eventId: 1,
      roundCode: WorldcupRoundDtoRoundCode.FINAL,
      roundName: '결승',
      sortOrder: 5,
      status: WorldcupRoundDtoStatus.PENDING,
      openAt: null,
      closedAt: null,
    },
  ],
  activeRoundCode: WorldcupRoundDtoRoundCode.R16,
};

const BASE_TICKETS = {
  result: 'OK',
  ticketBalance: 3,
  dailyLimit: 3,
  dailyGranted: {
    [WorldcupGrantSourceItemGameCode.punch]: false,
    [WorldcupGrantSourceItemGameCode.timeNyang]: false,
    [WorldcupGrantSourceItemGameCode.mulNyang]: true,
  },
  grantSources: [
    {
      gameCode: WorldcupGrantSourceItemGameCode.punch,
      label: '냥냥펀치',
      grantedToday: false,
    },
    {
      gameCode: WorldcupGrantSourceItemGameCode.timeNyang,
      label: '타임냥',
      grantedToday: false,
    },
    {
      gameCode: WorldcupGrantSourceItemGameCode.mulNyang,
      label: '물냥불냥',
      grantedToday: true,
    },
  ],
};

const quarterFinalMatches = {
  result: 'OK',
  roundCode: WorldcupRoundDtoRoundCode.R16,
  roundStatus: WorldcupRoundDtoStatus.OPEN,
  matches: [
    {
      matchId: 1001,
      kickoffAt: '2026-07-05T02:00:00+09:00',
      bettingCloseAt: '2026-07-05T00:00:00+09:00',
      status: WorldcupMatchItemResponseStatus.SCHEDULED,
      uiStatus: WorldcupMatchItemResponseUiStatus.BETTABLE,
      homeTeam: {
        teamId: 11,
        name: '스위스',
        flagUrl: '/assets/flags/worldcup-swiss.png',
        pickRate: 57,
        ticketSum: 205,
      },
      awayTeam: {
        teamId: 12,
        name: '캐나다',
        flagUrl: '/assets/flags/worldcup-canada.png',
        pickRate: 43,
        ticketSum: 155,
      },
      homeScore: null,
      awayScore: null,
      totalPoolPoint: 18000,
      estimatedPayoutPerTicket: 88,
      pointsPerTicket: 50,
      myPrediction: null,
    },
    {
      matchId: 1002,
      kickoffAt: '2026-07-05T06:00:00+09:00',
      bettingCloseAt: '2026-07-05T04:00:00+09:00',
      status: WorldcupMatchItemResponseStatus.BETTING_CLOSED,
      uiStatus: WorldcupMatchItemResponseUiStatus.CLOSED,
      homeTeam: {
        teamId: 13,
        name: '브라질',
        flagUrl: '/assets/flags/worldcup-brazil.png',
        pickRate: 61,
        ticketSum: 244,
      },
      awayTeam: {
        teamId: 14,
        name: '일본',
        flagUrl: '/assets/flags/worldcup-japan.png',
        pickRate: 39,
        ticketSum: 156,
      },
      homeScore: null,
      awayScore: null,
      totalPoolPoint: 20000,
      estimatedPayoutPerTicket: 82,
      pointsPerTicket: 50,
      myPrediction: {
        pickedTeamId: 14,
        ticketCount: 2,
        resultStatus: WorldcupMyPredictionResponseResultStatus.PENDING,
        earnedPoint: 0,
      },
    },
    {
      matchId: 1003,
      kickoffAt: '2026-07-06T02:00:00+09:00',
      bettingCloseAt: '2026-07-06T00:00:00+09:00',
      status: WorldcupMatchItemResponseStatus.FINISHED,
      uiStatus: WorldcupMatchItemResponseUiStatus.WIN,
      homeTeam: {
        teamId: 15,
        name: '프랑스',
        flagUrl: '/assets/flags/worldcup-france.png',
        pickRate: 49,
        ticketSum: 196,
      },
      awayTeam: {
        teamId: 16,
        name: '독일',
        flagUrl: '/assets/flags/worldcup-germany.png',
        pickRate: 51,
        ticketSum: 204,
      },
      homeScore: 1,
      awayScore: 2,
      totalPoolPoint: 20000,
      estimatedPayoutPerTicket: 98,
      pointsPerTicket: 50,
      myPrediction: {
        pickedTeamId: 16,
        ticketCount: 2,
        resultStatus: WorldcupMyPredictionResponseResultStatus.WIN,
        earnedPoint: 196,
      },
    },
    {
      matchId: 1004,
      kickoffAt: '2026-07-06T06:00:00+09:00',
      bettingCloseAt: '2026-07-06T04:00:00+09:00',
      status: WorldcupMatchItemResponseStatus.FINISHED,
      uiStatus: WorldcupMatchItemResponseUiStatus.NOT_PARTICIPATED,
      homeTeam: {
        teamId: 17,
        name: '한국',
        flagUrl: '/assets/flags/worldcup-korea.png',
        pickRate: 52,
        ticketSum: 208,
      },
      awayTeam: {
        teamId: 18,
        name: '포르투갈',
        flagUrl: '/assets/flags/worldcup-portugal.png',
        pickRate: 48,
        ticketSum: 192,
      },
      homeScore: 0,
      awayScore: 1,
      totalPoolPoint: 20000,
      estimatedPayoutPerTicket: 104,
      pointsPerTicket: 50,
      myPrediction: null,
    },
  ],
};

const semiFinalLockedMatches = {
  result: 'OK',
  roundCode: WorldcupRoundDtoRoundCode.SF,
  roundStatus: WorldcupRoundDtoStatus.PENDING,
  matches: [
    {
      matchId: 2001,
      kickoffAt: '2026-07-10T02:00:00+09:00',
      bettingCloseAt: '2026-07-10T00:00:00+09:00',
      status: WorldcupMatchItemResponseStatus.SCHEDULED,
      uiStatus: null,
      homeTeam: {
        teamId: null,
        name: '미정',
        flagUrl: null,
        pickRate: null,
        ticketSum: 0,
      },
      awayTeam: {
        teamId: null,
        name: '미정',
        flagUrl: null,
        pickRate: null,
        ticketSum: 0,
      },
      homeScore: null,
      awayScore: null,
      totalPoolPoint: 0,
      estimatedPayoutPerTicket: null,
      pointsPerTicket: 50,
      myPrediction: null,
    },
  ],
};

const BASE_HISTORY = {
  result: 'OK',
  predictions: [
    {
      predictionId: 9001,
      eventId: 1,
      matchId: 1003,
      userNo: 501,
      pickedTeamId: 16,
      ticketCount: 2,
      resultStatus: WorldcupPredictionDtoResultStatus.WIN,
      earnedPoint: 196,
      createdAt: '2026-07-05T18:00:00+09:00',
      settledAt: '2026-07-06T04:30:00+09:00',
    },
    {
      predictionId: 9002,
      eventId: 1,
      matchId: 1002,
      userNo: 501,
      pickedTeamId: 14,
      ticketCount: 2,
      resultStatus: WorldcupPredictionDtoResultStatus.PENDING,
      earnedPoint: 0,
      createdAt: '2026-07-05T03:00:00+09:00',
      settledAt: null,
    },
  ],
};

export const worldcupApiFixtures = {
  default: {
    eventOverviewResponse: BASE_EVENT,
    ticketStatusResponse: BASE_TICKETS,
    matchListResponses: [quarterFinalMatches, semiFinalLockedMatches],
    predictionHistoryResponse: BASE_HISTORY,
  },
  empty: {
    eventOverviewResponse: BASE_EVENT,
    ticketStatusResponse: {
      ...BASE_TICKETS,
      ticketBalance: 0,
      grantSources: BASE_TICKETS.grantSources.map((source) => ({
        ...source,
        grantedToday: false,
      })),
    },
    matchListResponses: [
      {
        result: 'OK',
        roundCode: WorldcupRoundDtoRoundCode.QF,
        roundStatus: WorldcupRoundDtoStatus.OPEN,
        matches: [],
      },
    ],
    predictionHistoryResponse: {
      result: 'OK',
      predictions: [],
    },
  },
  predictionSubmitted: {
    eventOverviewResponse: BASE_EVENT,
    ticketStatusResponse: {
      ...BASE_TICKETS,
      ticketBalance: 1,
    },
    matchListResponses: [
      {
        ...quarterFinalMatches,
        matches: quarterFinalMatches.matches.map((match) =>
          match.matchId === 1001
            ? {
                ...match,
                homeTeam: {
                  ...match.homeTeam,
                  pickRate: 58,
                  ticketSum: 206,
                },
                totalPoolPoint: 18100,
                estimatedPayoutPerTicket: 87,
                myPrediction: {
                  pickedTeamId: 11,
                  ticketCount: 2,
                  resultStatus: WorldcupMyPredictionResponseResultStatus.PENDING,
                  earnedPoint: 0,
                },
              }
            : match,
        ),
      },
      semiFinalLockedMatches,
    ],
    predictionHistoryResponse: {
      ...BASE_HISTORY,
      predictions: [
        {
          predictionId: 9004,
          eventId: 1,
          matchId: 1001,
          userNo: 501,
          pickedTeamId: 11,
          ticketCount: 2,
          resultStatus: WorldcupPredictionDtoResultStatus.PENDING,
          earnedPoint: 0,
          createdAt: '2026-07-04T23:55:00+09:00',
          settledAt: null,
        },
        ...BASE_HISTORY.predictions,
      ],
    },
  },
  allSettled: {
    eventOverviewResponse: {
      ...BASE_EVENT,
      rounds: BASE_EVENT.rounds.map((round) =>
        round.roundCode === WorldcupRoundDtoRoundCode.QF
          ? {
              ...round,
              status: WorldcupRoundDtoStatus.CLOSED,
              closedAt: '2026-07-07T00:00:00+09:00',
            }
          : round,
      ),
      activeRoundCode: null,
    },
    ticketStatusResponse: BASE_TICKETS,
    matchListResponses: [
      {
        ...quarterFinalMatches,
        roundStatus: WorldcupRoundDtoStatus.CLOSED,
        matches: quarterFinalMatches.matches.map((match) =>
          match.matchId === 1002
            ? {
                ...match,
                status: WorldcupMatchItemResponseStatus.FINISHED,
                uiStatus: WorldcupMatchItemResponseUiStatus.LOSE,
                homeScore: 2,
                awayScore: 1,
                myPrediction: {
                  pickedTeamId: 14,
                  ticketCount: 2,
                  resultStatus: WorldcupMyPredictionResponseResultStatus.LOSE,
                  earnedPoint: 0,
                },
              }
            : match,
        ),
      },
    ],
    predictionHistoryResponse: {
      ...BASE_HISTORY,
      predictions: BASE_HISTORY.predictions.map((prediction) =>
        prediction.matchId === 1002
          ? {
              ...prediction,
              resultStatus: WorldcupPredictionDtoResultStatus.LOSE,
              settledAt: '2026-07-05T07:30:00+09:00',
            }
          : prediction,
      ),
    },
  },
};

export const worldcupMockScenarios = Object.fromEntries(
  Object.entries(worldcupApiFixtures).map(([scenarioKey, fixtureSet]) => [
    scenarioKey,
    {
      key: scenarioKey,
      ...fixtureSet,
      pageViewModel: buildWorldcupPageViewModel(fixtureSet),
    },
  ]),
);

export const DEFAULT_WORLDCUP_SCENARIO_KEY = 'default';

export const getWorldcupMockScenario = (scenarioKey = DEFAULT_WORLDCUP_SCENARIO_KEY) => {
  return worldcupMockScenarios[scenarioKey] ?? worldcupMockScenarios[DEFAULT_WORLDCUP_SCENARIO_KEY];
};
